<div mat-dialog-content>
    {{message}}
</div>
<div mat-dialog-actions>
    <button mat-button color="warn" (click)="onNoClick()">No</button>
    <button mat-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>Yes</button>
</div>